export default __webpack_public_path__ + "static/media/comida.a7b592f3.png";